export default "__VITE_ASSET__WeVREgcw__"